import styled from 'styled-components';

export const MessagesShippingContainer = styled.div`
  margin-top: 16px;

  .ant-radio-group .anticon {
    margin-right: 8px;
  }
`;

export const MessagesShippingContent = styled.div`
  margin-top: 8px;
  display: flex;
  align-items: center;

  textarea:focus {
    border: 1px solid ${({ theme }) => theme.colors.primary} !important;
  }

  .ant-btn {
    display: block;
    margin-left: 8px;
    height: 54px;

    .anticon-paper-clip {
      transform: scale(1.2);
    }
  }
`;
